import Vue from "vue";

const formdunction = {
  install(Vue, options) {
    Vue.mixin({
      methods: {
        resizeInCanvas(img) {
          var perferedWidth = 1024;
          var ratio = perferedWidth / img.width;
          var canvas = document.createElement("canvas");
          canvas.width = img.width * ratio;
          canvas.height = img.height * ratio;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          return canvas.toDataURL(`image/jpeg`, 0.5);
        },
        resizeImages(file, callback) {
          var vm = this;
          var reader = new FileReader();
          reader.onload = function(e) {
            var img = new Image();
            img.onload = function() {
              callback(vm.resizeInCanvas(img));
            };
            img.src = e.target.result;
          };
          reader.readAsDataURL(file);
        },
        fileUpload(file, callback) {
          const reader = new FileReader();
          reader.onload = (event) => {
            callback(event.target.result);
          };
          reader.readAsDataURL(file);
        },
      },
    });
  },
};

Vue.use(formdunction);

export default {};
